import React from 'react';
import Faq from '../platformui/Faq';

export default (props) => <Faq {...props} />;
